export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20amber%20spotlights%20and%20rich%20crimson%20curtains%20texture%2C%20abstract%20film%20projector%20light%20beams%20casting%20soft%20glow%2C%20theater%20ambiance%20with%20elegant%20dramatic%20lighting%2C%20no%20text%2C%20no%20people%2C%20cinematic%20composition%2C%20deep%20shadows%20with%20warm%20highlights%2C%20luxurious%20velvet%20texture%20feel&width=1800&height=900&seq=hero-bg-movie&orientation=landscape"
          alt="影院氛围背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-200 text-sm font-medium font-label mb-4">
              <i className="ri-fire-line text-accent-400"></i>
              免费高清 · 不缓冲
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight mb-3">
              7788电影网
              <span className="block text-lg md:text-2xl lg:text-3xl font-normal text-background-200/90 mt-1">
                海量电影免费在线观看
              </span>
            </h1>

            <p className="text-accent-400 text-base md:text-lg font-medium font-heading mb-5">
              每日更新 · 高清流畅 · 畅享无限
            </p>

            <p className="text-background-200/80 text-sm md:text-base leading-relaxed mb-6 max-w-xl lg:max-w-none">
              7788电影网汇聚电影大全、最新电影与热门电影资源，提供<strong className="text-white font-medium">高清免费在线观看</strong>体验。本站每日持续更新片库，
              涵盖动作、悬疑、喜剧、科幻等全类型电影，<strong className="text-white font-medium">电影排行榜实时更新</strong>，
              帮你发现值得一看的优质影片。无论你是影迷老炮还是偶尔找片看，7788电影网都能让你畅享不缓冲的流畅高清播放。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="flex items-center gap-2 text-sm text-background-200/80">
                <i className="ri-movie-2-line text-accent-400 text-lg"></i>
                <span>每日上新 <strong className="text-white">50+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-200/80">
                <i className="ri-shield-check-line text-accent-400 text-lg"></i>
                <span>高清画质 <strong className="text-white">1080P</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-200/80">
                <i className="ri-speed-up-line text-accent-400 text-lg"></i>
                <span>极速加载 <strong className="text-white">不缓冲</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap px-7 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-trophy-line"></i>
                查看电影排行榜
              </a>
              <a
                href="#cards"
                className="whitespace-nowrap px-7 py-3 rounded-lg border border-background-300/40 text-white font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-film-line"></i>
                浏览新片速递
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20elegant%20cinema%20interior%20with%20plush%20red%20velvet%20seats%20and%20warm%20golden%20lighting%2C%20large%20blank%20movie%20screen%20with%20soft%20glow%2C%20luxurious%20theater%20atmosphere%2C%20rich%20burgundy%20and%20gold%20color%20palette%2C%20cinematic%20composition%2C%20no%20people%2C%20dramatic%20lighting&width=800&height=600&seq=hero-visual-movie&orientation=landscape"
                alt="7788电影网影院级观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}